import React, { memo } from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import nodeMap from 'utils/nodeMap';

interface IProps {
  images?: any;
  left?: React.ReactNode;
  switcher?: React.ReactNode;
  content?: React.ReactNode;
}

const useStyles = makeStyles()((theme) => ({
  root: {
    ...theme.mixins.scrollBarOverflowYAuto,
    height: '100%',
    background: 'white',
    overflowX: 'hidden',
    [theme.breakpoints.up('md')]: {
      overflowY: 'hidden',
      borderTopLeftRadius: 100,
    },
  },
  leftSidebar: {
    [theme.breakpoints.up('md')]: {
      overflow: 'hidden',
      borderBottomRightRadius: 100,
    },
  },
  left: {
    [theme.breakpoints.down('md')]: {
      alignItems: 'flex-start',
      alignContent: 'flex-start',
    },
  },
  img: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flex: '1 0 50%',
      height: '50%',
    },
  },
  right: {
    [theme.breakpoints.down('md')]: {
      overflow: 'hidden',
    },
    [theme.breakpoints.up('md')]: {
      height: '100%',
    },
    '& > *': {
      height: 'calc(100% + 32px)',
      padding: theme.spacing(3, 8),
      [theme.breakpoints.down('md')]: {
        padding: theme.spacing(5, 2),
        '& > *:nth-of-type(2)': {
          order: -1,
        },
      },
    },
  },
  switcher: {
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center',
    },
  },
  content: {
    height: '100%',
  },
}));

const CreateJliveAccountLayout: React.FC<React.PropsWithChildren<IProps>> = (props) => {
  const { images, switcher, left, content } = props;
  const { classes, cx } = useStyles();

  return (
    <Grid container className={cx(classes.root, { [classes.left]: Boolean(left) })}>
      {images && (
        <Grid item xs={12} md={6} className={cx(classes.leftSidebar, classes.img)}>
          {nodeMap(images, (image: React.ReactNode) => (
            <div>{image}</div>
          ))}
        </Grid>
      )}
      {left && (
        <Grid item xs={12} md={4} className={classes.leftSidebar}>
          {left}
        </Grid>
      )}
      <Grid item xs={12} md className={classes.right}>
        <Grid container spacing={4}>
          {switcher && (
            <Grid item xs={12} className={classes.switcher}>
              {switcher}
            </Grid>
          )}
          <Grid item xs={12} className={cx({ [classes.content]: !switcher })}>
            {content}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default memo(CreateJliveAccountLayout);
